import { Static, Type } from '@sinclair/typebox'

/**
 * A chat message says, by its own shape, whether it is a Tolgee key (with its
 * interpolation params) or free text (user data, or the model's own words),
 * never by whether `params` is present: a free-text value is never
 * translated, a key value is always looked up.
 */
export const AiBuilderText = Type.Union([
    Type.Object({ kind: Type.Literal('key'), key: Type.String(), params: Type.Record(Type.String(), Type.String()) }),
    Type.Object({ kind: Type.Literal('text'), text: Type.String() }),
])
export type AiBuilderText = Static<typeof AiBuilderText>

/** A Tolgee key (chat-messages.ts's own string value) with its interpolation params */
export const keyText = (key: string, params: Record<string, string> = {}): AiBuilderText => ({ kind: 'key', key, params })

/** User data or the model's own words — never translated */
export const freeText = (text: string): AiBuilderText => ({ kind: 'text', text })

/** Whether a raw string has nothing to say: a whitespace-only model answer is as empty as `''` */
export const isBlankText = (text: string): boolean => text.trim() === ''

/** Blank free text: the "nothing to say" value every producer returns */
export const isEmptyText = (text: AiBuilderText): boolean => text.kind === 'text' && isBlankText(text.text)

/** Whether `text` is the given key — the one way to compare against a known `AiBuilderMessageKey`/`AiBuilderSystemMessage` constant */
export const isKeyText = (text: AiBuilderText, key: string): boolean => text.kind === 'key' && text.key === key
